<template>
  <div class="content-8">
    <div class="content-8__titlebar">
      <div class="content-8__titlebar__left">
        <div class="c8-titlename">
          <span class="c8-titlename__text">开奖纪录</span>
        </div>
      </div>
      <div class="content-8__titlebar__right">
        <lottery-date-filter-tab :lottery-code="lotteryCode" @updateForm="chooseDate" />
      </div>
    </div>
    <!-- 號碼助手 -->
    <transition name="layout" mode="out-in">
      <HaoMaJhuShou
        v-if="hasHaoMaJuShou"
        :lottery-type="lotteryType"
      />
    </transition>
    <!-- 即時開獎 -->
    <transition name="tab" mode="out-in">
      <component
        :is="kaiJiangTable"
        ref="KaiJiangTable"
        :lottery-code="lotteryCode"
        :period-format="periodFormat"
        :lottery-type="lotteryType"
      />
    </transition>
  </div>
</template>

<script>
import k3KaiJiangTable from '@/components/web/pages/trend/JiShihKaiJiang/KaiJiangTable/k3'
import kl8KaiJiangTable from '@/components/web/pages/trend/JiShihKaiJiang/KaiJiangTable/kl8'
import xy28KaiJiangTable from '@/components/web/pages/trend/JiShihKaiJiang/KaiJiangTable/xy28'
import othersKaiJiangTable from '@/components/web/pages/trend/JiShihKaiJiang/KaiJiangTable/others'
import KaiJiangTable from '@/components/web/pages/trend/JiShihKaiJiang/KaiJiangTable'
import HaoMaJhuShou from '@/components/web/pages/trend/JiShihKaiJiang/HaoMaJhuShou'
import LotteryDateFilterTab from '@/components/web/pages/trend/LotteryDateFilterTab'
export default {
  name: 'LiShihKaiJiang',
  components: {
    k3KaiJiangTable,
    kl8KaiJiangTable,
    xy28KaiJiangTable,
    othersKaiJiangTable,
    KaiJiangTable,
    LotteryDateFilterTab,
    HaoMaJhuShou
  },
  props: {
    lotteryType: {
      type: String,
      default: '',
      requried: true
    }
  },
  data() {
    return {
      lotteryCode: this.$route.params.lottery_code,
      kaiJiangTable: null,
      periodFormat: {
        count: '30',
        date: undefined,
        year: undefined
      }
    }
  },
  computed: {
    hasMultiStatsLotteries() {
      return this.lotteryType === 'pk10' || this.lotteryType === 'kl10' || this.lotteryType === '11x5' || this.lotteryType === 'ssc'
    },
    hasHaoMaJuShou() {
      return this.hasMultiStatsLotteries
    }
  },
  mounted() {
    this.getKaiJiangTable()
  },
  methods: {
    getKaiJiangTable() {
      switch (this.lotteryType) {
        case 'k3':
          this.kaiJiangTable = k3KaiJiangTable
          break
        case 'kl8':
          this.kaiJiangTable = kl8KaiJiangTable
          break
        case 'xy28':
          this.kaiJiangTable = xy28KaiJiangTable
          break
        case 'others':
          this.kaiJiangTable = othersKaiJiangTable
          break
        default:
          this.kaiJiangTable = KaiJiangTable
          break
      }
    },
    chooseDate(form) {
      Object.assign(this.periodFormat, form)
    }
  }
}
</script>
